module.exports = __webpack_public_path__ + "media/images/avatar-upload-9195ba9ddf3f03aa7f62b96ef0bc6fb6.svg";